/**
 * Button type
 * @enum {string}
 * @property {string} BUTTON - Button type
 * @property {string} RESET - Reset type
 *  @property {string} SUBMIT - Submit type
 * @example
 * <Button type={ButtonType.BUTTON} />
 *
 */
export var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["RESET"] = "reset";
    ButtonType["SUBMIT"] = "submit";
})(ButtonType || (ButtonType = {}));
//# sourceMappingURL=type.js.map